import React, { Component } from 'react';
import SubScreenHeader from '../components/SubScreenHeader';
import LeftMenu from '../components/LeftMenu';
import AboutContent from '../components/Abouts/AboutContent';
import Footer from '../components/Footer';
import { Row, Col } from 'antd';
import StoreManager from '../appdata';
import DigitalBusiness2024Content from '../components/Abouts/DigitalBusiness2024Content';
import Game2024Content from '../components/Abouts/Game2024Content';
import VNGPeopleStrategyContent from '../components/Abouts/VNGPeopleStrategyContent';
import VNGsApproachToCSRContent from '../components/Abouts/VNGsApproachToCSRContent';
import Zalo2024Content from '../components/Abouts/Zalo2024Content';
import Zalopay2024Content from '../components/Abouts/Zalopay2024Content';
import languages from '../appdata/languages';

class AboutScreen extends Component {
  render() {
    const { subPageContent, isMobile } = StoreManager.appState.thisApp.state
    const lang = StoreManager.appState.thisApp.state.currentLanguage;
    
    const content = languages[lang].AppLanguage;

    const sections = [
      content.submenuAbout,
      content.submenuGame,
      content.submenuZalo,
      content.submenuZaloPay,
      content.submenuDB,
      content.submenuVNGPS,
      content.submenuVNGATCRS,
    ];
    return (
      <div>
        <SubScreenHeader title={content.aboutPageName} />

        <Row
          gutter={[32, 32]}
          style={{
            maxWidth: 1040,
            margin: '0 auto',
            paddingTop: 40,
            paddingBottom: 40,
            display: 'flex',
            alignItems: 'flex-start',
          }}
        >
          <Col
            xs={0}
            md={6}
            style={{
              maxHeight: 'calc(100vh - 160px)', // trừ phần header + padding
              overflowY: 'auto',
              position: 'sticky',
              top: 100,
            }}
          >
            <LeftMenu sections={sections} />
          </Col>
          <Col xs={24} md={18}>
            {
              subPageContent == 'AboutContent' ? <AboutContent /> : <></>
            }
            {
              subPageContent == 'DigitalBusiness2024Content' ? <DigitalBusiness2024Content /> : <></>
            }
            {
              subPageContent == 'Game2024Content' ? <Game2024Content /> : <></>
            }
            {
              subPageContent == 'VNGPeopleStrategyContent' ? <VNGPeopleStrategyContent /> : <></>
            }
            {
              subPageContent == 'VNGsApproachToCSRContent' ? <VNGsApproachToCSRContent /> : <></>
            }
            {
              subPageContent == 'Zalo2024Content' ? <Zalo2024Content /> : <></>
            }
            {
              subPageContent == 'Zalopay2024Content' ? <Zalopay2024Content /> : <></>
            }
          </Col>
        </Row>

        <Footer />
      </div>
    );
  }
}

export default AboutScreen;
